import { call, select } from 'redux-saga/effects'

import { types as lifecycleTypes } from 'common/modules/lifecycle/actions'
import { types as arbiterTypes } from 'common/modules/arbiter/actions'
import Loader from 'common/modules/loader'
import Zoid from 'common/modules/zoid'

let picoReady = false
let mutatorsReady = false
let getLoaderSuccess = false

function* isReady() {
    const conditionsAreReady = (
        picoReady
        && mutatorsReady
        && getLoaderSuccess
    )

    if (!conditionsAreReady) {
        return null
    }

    const userWindowObject = yield select(Loader.selectors.userWindowObject)
    const xprops = yield select(Zoid.selectors.getXprops)

    yield call(xprops.UpdateWindowUser, userWindowObject)

    return {
        detail: userWindowObject,
    }
}

export default {
    [Loader.types.GET_LOADER_SUCCESS]: [
        {
            event: 'pico.loaded',
            * data() {
                getLoaderSuccess = true

                return yield isReady()
            },
        },
    ],
    [arbiterTypes.PICO_READY]: [
        {
            event: 'pico.loaded',
            * data() {
                picoReady = true

                return yield isReady()
            },
        },
    ],
    [lifecycleTypes.MUTATORS_READY]: [
        {
            event: 'pico.loaded',
            * data() {
                mutatorsReady = true

                return yield isReady()
            },
        },
    ],
}
